/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
import type { FDCPASettings } from './FDCPASettings';
import {
  FDCPASettingsFromJSON,
  FDCPASettingsFromJSONTyped,
  FDCPASettingsToJSON,
} from './FDCPASettings';

/**
 *
 * @export
 * @interface GlobalSettingsPatch
 */
export interface GlobalSettingsPatch {
  /**
   *
   * @type {FDCPASettings}
   * @memberof GlobalSettingsPatch
   */
  fdcpaSettings?: FDCPASettings;
}

/**
 * Check if a given object implements the GlobalSettingsPatch interface.
 */
export function instanceOfGlobalSettingsPatch(
  value: object,
): value is GlobalSettingsPatch {
  return true;
}

export function GlobalSettingsPatchFromJSON(json: any): GlobalSettingsPatch {
  return GlobalSettingsPatchFromJSONTyped(json, false);
}

export function GlobalSettingsPatchFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GlobalSettingsPatch {
  if (json == null) {
    return json;
  }
  return {
    fdcpaSettings:
      json['fdcpa_settings'] == null
        ? undefined
        : FDCPASettingsFromJSON(json['fdcpa_settings']),
  };
}

export function GlobalSettingsPatchToJSON(
  value?: GlobalSettingsPatch | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    fdcpa_settings: FDCPASettingsToJSON(value['fdcpaSettings']),
  };
}
